/* 
@example 
    
    export const ENDPOINT_ACTION_NAME = "/endpoint-url"
*/

// @labX URL
export const NEW_ORDER_URL = "/lite/v2/api/v3/placeorder";

export const EXISTING_URL = "/lite/v2/api/v3/process";

export const BOAT_URL = "/lite/v2/api/v3/boat/process";

export const NOTIFICATION_URL = "/lite/v2/api/admin/cylinder/notify-hospital";

export const COMPLETE_URL = "/lite/v2/api/admin/cylinder/complete";

export const NOTIFY_URL = "/lite/v2/api/admin/cylinder/return";

// stockbank products
export const PRODUCTS_URL = "/lite/v2/api/v3/stockbank/product";
